import { Button } from "devextreme-react";
import { DropDownOptions } from "devextreme-react/drop-down-box";
import { Form, GroupItem, SimpleItem } from "devextreme-react/form";
import { forwardRef, useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { DropDownGrid, Modal } from "../../components";
import { getApiParams } from "../../redux/auth";
import { BodyType, createRequest } from "../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../redux/base/types/saga";
import { getLocalized } from "../../redux/localization";
import { Category } from "../account/detail/tabs/product/type";
import { renderInformationItem } from "../productRequestPage/detail";
import SelectIcon from "./selectIcon";
import { ProductFeatures, ProductFeatureValueType } from "./type";


const createProductFeaturesForm = forwardRef<any, { data: ProductFeatures }>((
    { data }, ref
) => {
    const localize = useSelector(getLocalized);
    const [, setId] = useState()
    const [, setId1] = useState()
    const [categories, setCategories] = useState<Category[]>([])
    const [productFeatureType, setProductFeatureType] = useState<ProductFeatureValueType[]>([])
    const { token, lang } = useSelector(getApiParams);
    const [show, setShow] = useState(false)

    const iconRef = useRef<any>();


    const getCategories = useCallback((async () => {
        const response: ApiResponse<Category[]> = await createRequest({
            method: "GET",
            url: "/api/dashboardview/categories",
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setCategories(response.Result)
        }
    }), [token, lang])

    const getProductFeatureValueTypes = useCallback((async () => {
        const response: ApiResponse<ProductFeatureValueType[]> = await createRequest({
            method: "GET",
            url: "/api/admin/productfeatures/get-product-feature-value-types",
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setProductFeatureType(response.Result)
        }
    }), [token, lang])

    useEffect(() => {
        getProductFeatureValueTypes()
        getCategories()
    }, [getCategories, getProductFeatureValueTypes])
    return <Form
        formData={data}
        ref={ref}
        validationGroup="createProductFeature"
    >
        <GroupItem>
            <SimpleItem
                dataField={"Code"}
                editorType={"dxTextBox"}
                label={{
                    text: localize.getString("code"),
                }}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"Name"}
                editorType={"dxTextBox"}
                label={{
                    text: localize.getString("name"),
                }}
            >
            </SimpleItem>

            <SimpleItem
                dataField="ProductCategoryId"
                editorType="dxLookup"
                label={{ text: localize.getString("category") }}
                render={(item: any) => (
                    <DropDownGrid
                        dataSource={categories}
                        columns={["Name", "Order"]}
                        displayExpr="Name"
                        returnSelectedId={async (id: any) => {
                            item.editorOptions.value = id
                            data.ProductCategoryId = id
                            setId(id);
                        }}

                        value={data.ProductCategoryId}
                        dropDownOptions={{ width: 500 }}
                    />
                )}
            >
                <DropDownOptions closeOnOutsideClick showTitle={false} />
            </SimpleItem>
            <SimpleItem
                dataField="ProductFeatureValueTypeId"
                editorType="dxLookup"
                label={{ text: localize.getString("ProductFeatureValueTypeName") }}
                render={(item: any) => (
                    <DropDownGrid
                        dataSource={productFeatureType}
                        columns={["Code"]}
                        displayExpr="Code"
                        returnSelectedId={async (id: any) => {
                            item.editorOptions.value = id
                            data.ProductFeatureValueTypeId = id
                            setId1(id);
                        }}

                        value={data.ProductFeatureValueTypeId}
                        dropDownOptions={{ width: 500 }}
                    />
                )}
            >
                <DropDownOptions closeOnOutsideClick showTitle={false} />
            </SimpleItem>
            <SimpleItem
                dataField={"Icon"}
                render={renderInformationItem}
                label={{
                    text: localize.getString("icon"),
                }}

            >

            </SimpleItem>
        </GroupItem>

        <GroupItem>
            <Button
                type="success"
                text="Icon Seç"
                onClick={() => {
                    setShow(true)
                }}
            >

            </Button>
            <Modal
                visible={show}
                onHiding={() => { setShow(false) }}
                title={"Icon Seçme Formu"}
                width="60%"
                height="85%"
                onSubmitClick={async () => {

                    iconRef.current.instance.resetValues();
                    setShow(false)
                    
                }}>
                <div style={{
                    display: "flex",
                    justifyContent: "center"
                }}>
                    <SelectIcon data={data} ref={iconRef}></SelectIcon>
                </div>
            </Modal>
            
        </GroupItem>

    </Form>

})

export default createProductFeaturesForm;